<template>
  <div class='common-main'>
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'common-main',
};
</script>

<style lang="scss">
  .common-main {
    height: 100%;
    width: 100%;
    overflow:hidden;
  }
</style>



// WEBPACK FOOTER //
// src/views/commonMain.vue